import React, { useEffect, useState } from "react";
import plus_white from "../../assets/icons/plus_white.svg";
import { ThreeDots } from "react-loader-spinner";
import Modal from "../../components/Modals/modal";
import {
  addInfoTypeCategories,
  handleCategoryChange,
} from "../../redux/Catalog/catalog";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchTypeCategories } from "../../redux/Catalog/catalogActions";

const AddProducts = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { categories, loader } = useSelector((state) => state.catalog);
  const [show, setShow] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategoryID, setSelectedCategoryID] = useState(null);

  const showModal = () => {
    setShow(!show);
  };

  const [productType] = useState([
    {
      id: 1,
      tag: "crop",
      text: "Crop",
    },
    {
      id: 2,
      tag: "livestock",
      text: "Livestock",
    },
    {
      id: 3,
      tag: "advisory",
      text: "Advisory",
    },
    {
      id: 4,
      tag: "insurance",
      text: "Insurance",
    },
    {
      id: 5,
      tag: "info",
      text: "Info Card",
    },
  ]);

  const infoType = [
    {
      id: 1,
      name: "Crop",
    },
    {
      id: 2,
      name: "Livestock",
    },
    {
      id: 3,
      name: "Advisory",
    },
    {
      id: 4,
      name: "Insurance",
    },
  ];

  const [typeId, setTypeId] = useState(1);
  const [typeName, setTypeName] = useState("Crop");
  const toggleType = (val) => {
    const { id, text } = val;
    setTypeId(id);
    setTypeName(text);
    setSelectedCategory(null);
    // setSelectedCategoryID(null)
    switch (id) {
      case 1:
        dispatch(
          fetchTypeCategories({
            val: "input_product_categories",
          })
        );
        break;
      case 2:
        dispatch(
          fetchTypeCategories({
            val: "livestock_product_categories",
          })
        );
        break;
      case 3:
        dispatch(
          fetchTypeCategories({
            val: "advisory_product_categories",
          })
        );
        break;
      case 4:
        dispatch(
          fetchTypeCategories({
            val: "insurance_product_categories",
          })
        );
        break;
      case 5:
        dispatch(addInfoTypeCategories(infoType));
        break;
      default:
        break;
    }
  };

  const pickCategory = (name, id) => {
    setSelectedCategory(name);
    setSelectedCategoryID(id);
  };

  const handleAdd = (category) => {
    if (category === "Crop") {
      dispatch(
        handleCategoryChange({
          type: "CROP",
          name: selectedCategory,
          id: selectedCategoryID,
        })
      );
      return navigate(`/add-product/${selectedCategory}`);
    }

    if (category === "Info Card") {
      return navigate(`/product-catalogue/addinfocard/${selectedCategory}`);
    }
  };

  useEffect(() => {
    dispatch(
      fetchTypeCategories({
        val: "input_product_categories",
      })
    );
  }, [dispatch]);
  return (
    <div>
      <Modal
        show={show}
        showModal={showModal}
        title="Add Product"
        subtitle="Please select the product type you want to add"
      >
        <ul className="flex gap-4 mt-5">
          {productType.map((val) => (
            <>
              <li
                key={val.id}
                onClick={() => {
                  toggleType(val);
                }}
                className={
                  typeId === val.id
                    ? "text-primary font-medium text-sm border-b-2  border-primary cursor-pointer"
                    : "text-[#96A397] text-sm font-medium cursor-pointer"
                }
              >
                {val.text}
              </li>
            </>
          ))}
        </ul>

        <div className="mt-5 flex gap-4 flex-wrap">
          {!loader && categories.length
            ? categories.map((item) => {
                return (
                  <div
                    key={item.id}
                    onClick={() => pickCategory(item.name, item.id)}
                    className={
                      selectedCategory === item.name
                        ? "rounded-[4px] bg-[#EDF7EE] border border-primary py-2 px-4 cursor-pointer"
                        : "rounded-[4px] border border-[#96A397] py-2 px-4 cursor-pointer"
                    }
                  >
                    <p
                      className={
                        selectedCategory === item.name
                          ? "text-primary text-sm font-medium"
                          : "text-[#96A397] text-sm font-medium"
                      }
                    >
                      {item.name}
                    </p>
                  </div>
                );
              })
            : ""}
        </div>

        {loader && (
          <div className="flex flex-col items-center h-[100px] justify-center">
            <ThreeDots
              height={40}
              width={30}
              color="#4fa94d"
              visible={true}
              secondaryColor="#4fa94d"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          </div>
        )}

        <div className="flex justify-end mt-6 mb-3">
          <button
            type="submit"
            onClick={() => handleAdd(typeName)}
            disabled={selectedCategory === null}
            className="bg-primary 
                    disabled:bg-[#ABB6AC] 
                    rounded-lg px-8 py-4 text-white text-sm font-medium hover:bg-[#24752B] transition-all"
          >
            Continue
          </button>
        </div>
      </Modal>{" "}
      <button
        onClick={showModal}
        className="w-full py-4 flex items-center justify-center px-6 bg-[#2B8C34] rounded-[8px] text-white hover:text-white text-sm font-medium  hover:bg-[#24752B] transition-all"
      >
        <img src={plus_white} alt="plus icon" />
        <p className="text-white font-medium text-sm ml-2">Add Product</p>
      </button>
    </div>
  );
};

export default AddProducts;
